//! pertains to iMIS OOB functionality

function selectImageManagerImage(callback) {
    getImageManagerUrl(function (imageManagerPopupData) {
        setupImageManagerWindow(imageManagerPopupData);

        VAIMISUtilityV2.Popup.createPopup({
            url: imageManagerPopupData.url,
            title: "Select Image",
            width: imageManagerPopupData.width,
            height: imageManagerPopupData.height,
            callback: function (sender, args) {
                // reset auto size
                sender.set_autoSize(false);

                // get the selected image if any
                let argValue = args.get_argument();
                if (argValue != null) {
                    let imgSrc = argValue.get_value()[0].src;
                    let cleanImgSrc = imgSrc.replace(location.origin, "");

                    callback(cleanImgSrc);
                }
            }
        });
    });
}

function getImageManagerUrl(callback) {
    let imageManagerPageUrl = getImageManagerPageUrl();

    // setup a "hidden" iFrame that loads the image manager page url
    let jIframe = jQuery("<iframe style='display: none; height: 1000px; width: 100%;' src='" + imageManagerPageUrl + "' />");
    jIframe.on("load", function () {
        let contentWindow = (<HTMLIFrameElement>this).contentWindow;
        contentWindow.jQuery(function () {
            // inside the iframe trigger a click so the popup opens again (to ensure we get the popup active window after it has been created)
            contentWindow.jQuery("[id$=_ContentPanel]>input").trigger("click");
            let activeWindow = contentWindow.GetRadWindowManager().getActiveWindow();

            // get the Image Manager url and dimensions
            let callbackData = {
                url: activeWindow.get_navigateUrl(),
                dialogParameters: activeWindow["DialogParameters"]
            }

            jIframe.remove();
            callback(callbackData);
        });
    });

    jQuery("form").append(jIframe);
}

function getImageManagerPageUrl() {
    let imageManagerPageUrl = "";

    // get the page url from the side navigation available on the staff site
    let tRadTree: Telerik.Web.UI.RadTreeView = $find(jQuery("[id$=_SubNavigationTree]").attr("id"));
    if (tRadTree != null) {
        let tNode = tRadTree.findNodeByText("Manage images");
        if (tNode != null) {
            imageManagerPageUrl = tNode.get_navigateUrl();
        }
    }

    // if not found, default to hardcoded URL
    if (VAIMISUtilityV2.General.isStringNullOrEmpty(imageManagerPageUrl)) {
        imageManagerPageUrl = "/iMIS/ContentManagement/ImageManager.aspx";
    }

    imageManagerPageUrl = VAIMISUtilityV2.Url.getUrlStringWithParams(imageManagerPageUrl, {
        TemplateType: "E"
    });
    return imageManagerPageUrl;
}

function setupImageManagerWindow(imageManagerPopupData) {
    // check for dialogParameters and add callback to add them to the RadWindow object before frame loads
    let radWindow = window.GetRadWindowManager().getWindowByName("GenericWindow");
    if (imageManagerPopupData.dialogParameters != null) {
        const cb = function (sender, args) {
            sender.DialogParameters = imageManagerPopupData.dialogParameters;
            sender.remove_beforeShow(cb);
        };

        radWindow.add_beforeShow(cb);
    }
    radWindow["ClientParameters"] = {};
    radWindow.set_autoSize(true);
}

export {
    selectImageManagerImage
};
